import {
    min, max, required, requiredIf,
} from '~/services/validators';

export default {
    validations: {
        anonymous: [],
        description: [
            required,
            { validator: min, length: 5 },
            { validator: max, length: 250 },
        ],
        existingMedia: [],
        images: [
            { validator: requiredIf, field: 'existingMedia', value: [] },
        ],
        land_type: [
            required,
        ],
        latLng: [
            { validator: requiredIf, field: 'what3words', value: '' },
        ],
        location: [
            required,
        ],
        road: [
            { message: 'error_messages.road', validator: required },
        ],
        what3words: [
            { validator: requiredIf, field: 'latLng', value: '' },
        ],
    },
};
